import {
	EDIT,
	isExportMode,
	getMode,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import { getHierarchyFilter } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/filters/hierarchy-filter';
import { getHierarchyLevels } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/hierarchy';
import { getScope } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/scope';
import type { Mode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/app/types';
import type {
	Scope,
	ScopeIssue,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/scope/types';
import type {
	HierarchyFilter,
	HierarchyRangeFilter,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/filters/types';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import type { HierarchyLevel } from '@atlassian/jira-portfolio-3-portfolio/src/common/api/types';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { StateProps } from './types';

export default createSelector<
	State,
	HierarchyLevel[],
	// keep only "HierarchyRangeFilter" when removing the "use-jira-hierarchy-levels-in-plans_knftc" feature flag
	HierarchyFilter | HierarchyRangeFilter,
	Scope<ScopeIssue>,
	boolean,
	Mode,
	StateProps
>(
	[getHierarchyLevels, getHierarchyFilter, getScope, isExportMode, getMode],
	(
		hierarchy,
		{ value: { start, end } },
		{ startLevelIssues: { rootIssuesCount } },
		exportMode,
		mode,
	) => ({
		hierarchy,
		start,
		end,
		rankDigits: rootIssuesCount.toString().length,
		isReadOnly: mode !== EDIT, // Not quite the same as the usual isReadOnly selector
		isExportMode: exportMode,
	}),
);
